var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.654.054a6.596 6.596 0 014.091.799 6.425 6.425 0 012.759 3.086 6.286 6.286 0 01.274 4.106 6.384 6.384 0 01-2.326 3.415 6.572 6.572 0 01-3.761 1.313l1.977 1.94a.75.75 0 11-1.05 1.07l-3.286-3.221a.75.75 0 010-1.071l3.286-3.222a.75.75 0 011.05 1.071l-1.97 1.933a5.073 5.073 0 002.852-1.011 4.883 4.883 0 001.781-2.612 4.785 4.785 0 00-.209-3.128 4.924 4.924 0 00-2.116-2.364 5.096 5.096 0 00-3.16-.616 5.045 5.045 0 00-2.887 1.395 4.847 4.847 0 00-1.416 2.815 4.796 4.796 0 00.624 3.075.75.75 0 11-1.293.76 6.296 6.296 0 01-.818-4.035 6.347 6.347 0 011.853-3.686A6.545 6.545 0 016.654.054z",
    fill: "currentColor"
  })));
}
export default SvgRestore;